import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { BACKEND_URL } from "../../config/env";
import { Checkbox, Stack } from "@mui/material";
import ChatiaDialogActions from "../ChatiaDialogActions";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  btnWrapper: {
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

const FlowBuilderAddVideoModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState(false);
  const [preview, setPreview] = useState();
  const [labels, setLabels] = useState({
    title: i18n.t("flowBuilderModals.singleBlockModal.titleAdd"),
    btn: i18n.t("flowBuilderModals.singleBlockModal.buttonAdd")
  });
  const [medias, setMedias] = useState([]);

  useEffect(() => {
    if (open === "edit") {
      setLabels({ title: i18n.t("flowBuilderModals.singleBlockModal.titleEdit"), btn: i18n.t("flowBuilderModals.singleBlockModal.buttonSave") });
      setPreview(
        BACKEND_URL + "/public/" + data.data.url
      );
      setRecord(data.data.record);
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({ title: i18n.t("flowBuilderModals.singleBlockModal.titleAdd"), btn: i18n.t("flowBuilderModals.singleBlockModal.buttonAdd") });
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => () => { isMounted.current = false; }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  // -------- FIX: endpoint correto + edição --------
  const handleSaveContact = async () => {
    if (open === "edit") {
      if (medias.length > 0) {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append("fromMe", true);
          medias.forEach(media => formData.append("medias", media));
          const { data: res } = await api.post("/flowbuilder/video", formData);
          onUpdate({ ...data, data: { url: res.name, record } });
          toast.success(i18n.t("flowBuilderModals.singleBlockModal.messages.contentAddedSuccess"));
        } catch (err) {
          toastError(err);
        } finally {
          setLoading(false);
          handleClose();
        }
      } else {
        onUpdate({ ...data, data: { ...data.data, record } });
        handleClose();
      }
      return;
    }

    // CREATE (novo upload)
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("fromMe", true);
      medias.forEach(media => formData.append("medias", media));
      const { data: res } = await api.post("/flowbuilder/video", formData);
      onSave({ url: res.name });
      toast.success(i18n.t("flowBuilderModals.singleBlockModal.messages.contentAddedSuccess"));
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
      setMedias([]);
      setPreview();
      handleClose();
    }
  };
  // -------- /FIX ----------------------------------

  const handleChangeMedias = e => {
    if (!e.target.files) return;
    if (e.target.files[0].size > 20000000) {
      toast.error(i18n.t("flowBuilderModals.singleBlockModal.validation.fileTooLarge20MB"));
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setPreview(URL.createObjectURL(e.target.files[0]));
    setMedias(selectedMedias);
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">{labels.title}</DialogTitle>
        <Stack>
          <DialogContent dividers>
            <Stack gap="16px">
              {preview && (
                <Stack direction="row" justifyContent="center">
                  <video controls width="552px">
                    <source src={preview} type="video/mp4" />
                    {i18n.t("flowBuilderModals.singleBlockModal.validation.browserNotSupported")}
                  </video>
                </Stack>
              )}
              {/* FIX: botão visível sempre */}
              {!loading && (
                <>
                  <Button variant="contained" component="label">
                    {i18n.t("flowBuilderModals.singleBlockModal.buttons.sendVideo")}
                    <input
                      type="file"
                      accept="video/mp4"
                      hidden
                      disabled={loading}
                      onChange={handleChangeMedias}
                    />
                  </Button>
                  {!preview && (
                    <Typography>{i18n.t("flowBuilderModals.singleBlockModal.validation.onlyMp4Videos")}</Typography>
                  )}
                </>
              )}
              {loading && (
                <Stack justifyContent="center" alignSelf="center">
                  <CircularProgress />
                </Stack>
              )}
            </Stack>
          </DialogContent>
          {!loading && (
            <ChatiaDialogActions
              type="button"
              onClick={handleSaveContact}
              disabled={loading}
              loading={loading}
              saveText={labels.btn}
            />
          )}
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddVideoModal;
